import axios from "axios";
import { errorResponse } from "src/store/common";
import { 
    alertMessages, 
    createUpdateDeadFuelCatalogQuery, 
    createUpdateLiveFuelCatalogMutation, 
    createUpdateDroughtCatalogQuery,
    createUpdateFuelModelCatalogQuery,
    deleteLiveFuelCatalogMutation, 
    deleteDroughtCatalogMutation, 
    deleteFireDangerModelCatalogMutation, 
    deleteDeadFuelCatalogMutation
} from "src/constants";
import { configMutationClimatology } from "./mutationsApiKey";

export const createUpdateDeadCatalogCall = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: createUpdateDeadFuelCatalogQuery,
            variables: {
                id: params.id,
                name: params.name,
                hr1StickRadius: params.hr1StickRadius,
                hr10StickRadius: params.hr10StickRadius,
                hr100StickRadius: params.hr100StickRadius,
                hr1000StickRadius: params.hr1000StickRadius,
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {

                            return resolve(response)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error', error);
                        return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.deadCatalogCreate);

    }
};


export const createUpdateDroughtCatalogCall = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: createUpdateDroughtCatalogQuery,
            variables: {
                id: params.id,
                catalogName: params.catalogName,
                kbdiInitial: params.kbdiInitial,
                kbdiThreshold: params.kbdiThreshold,
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {

                            return resolve(response)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error', error);
                        return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.deadCatalogCreate);

    }
};


export const createUpdateFuelModelCatalogCall = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: createUpdateFuelModelCatalogQuery,
            variables: {
                fireDangerModelCatalog: params
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {

                            return resolve(response)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error', error);
                        return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.fuelModelCatalogCreate);

    }
};

export const createUpdateLiveCatalogCall = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: createUpdateLiveFuelCatalogMutation,
            variables: {
                id: params.id,
                name: params.name,
                herbDaysAvg: params.herbDaysAvg,
                herbMaxGsi: params.herbMaxGsi,
                herbGreenup: params.herbGreenup,
                herbMax: params.herbMax,
                herbMin: params.herbMin,
                herbTempMinMax: params.herbTempMinMax,
                herbTempMinMin: params.herbTempMinMin,
                herbVpdMin: params.herbVpdMin,
                herbVpdMax: params.herbVpdMax,
                herbDayLengthMin: params.herbDayLengthMin,
                herbDayLengthMax: params.herbDayLengthMax,
                herbVpdAvgFlg: params.herbVpdAvgFlg,
                woodyDaysAvg: params.woodyDaysAvg,
                woodyMaxGsi: params.woodyMaxGsi,
                woodyGreenup: params.woodyGreenup,
                woodyMax: params.woodyMax,
                woodyMin: params.woodyMin,
                woodyTempMinMax: params.woodyTempMinMax,
                woodyTempMinMin: params.woodyTempMinMin,
                woodyVpdMin: params.woodyVpdMin,
                woodyVpdMax: params.woodyVpdMax,
                woodyDayLengthMin: params.woodyDayLengthMin,
                woodyDayLengthMax: params.woodyDayLengthMax,
                woodyVpdAvgFlg: params.woodyVpdAvgFlg,
                herbPrecipTotalMin: params.herbPrecipTotalMin,
                herbPrecipTotalMax: params.herbPrecipTotalMax,
                herbTotalPrecipDays: params.herbTotalPrecipDays,
                herbUsePrecipFlg: params.herbUsePrecipFlg,
                woodyPrecipTotalMin: params.woodyPrecipTotalMin,
                woodyPrecipTotalMax: params.woodyPrecipTotalMax,
                woodyTotalPrecipDays: params.woodyTotalPrecipDays,
                woodyUsePrecipFlg: params.woodyUsePrecipFlg,
                woodyCalibration: params.woodyCalibration,
                herbCalibration: params.herbCalibration
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {

                            return resolve(response)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error', error);
                        return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.liveCatalogCreate);

    }
};

export const deleteFuelCatalog = (params: any, catalogCategory:any, addAlert: any) => {
    try {
        let deleteGraphqlString: string = '';
        if(catalogCategory === 'Live') {
            deleteGraphqlString = deleteLiveFuelCatalogMutation;
        } else if (catalogCategory === 'Dead') {
            deleteGraphqlString = deleteDeadFuelCatalogMutation
        } else if (catalogCategory === 'Drought') {
            deleteGraphqlString = deleteDroughtCatalogMutation;
        } else if (catalogCategory === 'Parent') {
            deleteGraphqlString = deleteFireDangerModelCatalogMutation;
        }
        let data = JSON.stringify({
            query: deleteGraphqlString,
            variables: {
                id: params.id
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                .then(async function (response: any) {
                    if (response?.data.errors) {
                        return reject(new Error(response.data.errors[0].message));
                    }
                    else {
                        if(catalogCategory === 'Live') {
                            return resolve(response.data.data.deleteLiveFuelCatalog);
                        } else if (catalogCategory === 'Dead') {
                            return resolve(response.data.data.deleteDeadFuelCatalog);
                        } else if (catalogCategory === 'Drought') {
                            return resolve(response.data.data.deleteDroughtCatalog);
                        } else if (catalogCategory === 'Parent') {
                            return resolve(response.data.data.deleteFireDangerModelCatalog);
                        }
                    }
                })
                .catch(function (error: any) {
                    console.log('error', error);
                    return reject(new Error(error))
                });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.report);
    }
};